import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { salesPageData, isPlaceholder } from '../data/salesPageData';
export function GuaranteeSection() {
  const hasEmail = !isPlaceholder(salesPageData.supportEmail);
  return <section id="garantia" className="bg-[#F8F3EA] text-[#111111]" aria-labelledby="guarantee-title" data-id="element-119" data-mp="9tl7ct61zbs7">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-120" data-mp="eu8xzdqddqlw">
        <div className="mx-auto max-w-3xl text-center" data-id="element-121" data-mp="jtbzwpb1zgpn">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl border-2 border-[#3A2416]/20 bg-white shadow-[0_18px_40px_-24px_rgba(17,17,17,0.5)]" data-id="element-122" data-mp="jqptwu3t999j">
            <ShieldCheckIcon className="h-9 w-9 text-[#E96800]" aria-hidden="true" data-id="element-123" data-mp="slmcuedc20al" />
          </span>

          <p className="mt-6 font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-[#E96800]" data-id="element-124" data-mp="xj5pj9udu50f">
            🛡 Tu compra está protegida
          </p>

          <h2 id="guarantee-title" className="reveal mt-4 font-display text-2xl font-black uppercase leading-[1.1] tracking-tight sm:text-4xl" data-id="element-125" data-mp="17j6dj93759ay">
            Tenés {salesPageData.guaranteeDays} días para abrir la Bóveda y mirarla por
            dentro.
          </h2>

          <div className="mx-auto mt-8 max-w-xl space-y-1.5 text-[15px] leading-relaxed text-[#111111]/75 sm:text-base" data-id="element-126" data-mp="1vthgsgyyjenw">
            <p data-id="element-127" data-mp="1rsxmdl5rqp5g">Entrá.</p>
            <p data-id="element-128" data-mp="1rtqjrviu82ax">Explorá los proyectos.</p>
            <p data-id="element-129" data-mp="2oieyoiz9b9g4">Revisá las categorías.</p>
            <p data-id="element-130" data-mp="2ohdcpjgpd2jm">Abrí los 8 Bonos Especiales.</p>
            <p data-id="element-131" data-mp="2ok9b18wgpt8l">Comprobá por tu cuenta qué recibiste.</p>
          </div>

          <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-[#111111]/70" data-id="element-132" data-mp="2jjvbkf8xfrm6">
            Tu compra cuenta con una garantía de {salesPageData.guaranteeDays} días. Si
            dentro del período correspondiente considerás que el material no coincide
            con lo presentado en esta página, podés comunicarte con soporte para
            solicitar la devolución conforme a las condiciones vigentes.
          </p>

          {hasEmail && <p className="mt-4 text-sm font-semibold text-[#111111]" data-id="element-133" data-mp="10kxc3lrveds3">
              Correo:{' '}
              <a href={`mailto:${salesPageData.supportEmail}`} className="text-[#E96800] underline underline-offset-4" data-id="element-134" data-mp="15jh2bydhybq9">
                {salesPageData.supportEmail}
              </a>
            </p>}

          <p className="reveal mt-10 border-t border-[#111111]/10 pt-8 font-display text-lg font-black uppercase leading-tight tracking-tight sm:text-2xl" data-id="element-135" data-mp="vtnsb1t064o4">
            No tenés que decidir a ciegas.
            <span className="block text-[#E96800]" data-id="element-136" data-mp="mszfgafciact">
              Podés ver la Bóveda por dentro.
            </span>
          </p>
        </div>
      </div>
    </section>;
}